<template>
  <v-dialog :value="open" :width="768" scrollable persistent>
    <v-card>
      <div v-show="isDialogLoading" class="text-xs-center py-3">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <v-card-title v-show="!isDialogLoading">
        <v-btn icon flat left class="ml-auto" @click="$emit('update:open', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-show="!isDialogLoading">
        <v-container fluid grid-list-md class="pa-0" :style="{ width: '100% !important' }">
          <v-layout wrap align-center>
            <v-flex xs12 class="form-control">
              <input
                v-model="query"
                type="text"
                :placeholder="$t('Search')"
                class="ma-0"
                @input="debounceSearch()"
              />
            </v-flex>
          </v-layout>
        </v-container>
        <div class="mt-3">
          <FacebookTemplateList
            :items="items"
            :page="filters.page"
            :total-pages="Math.ceil(total / filters.limit)"
            @update:page="handlePageUpdate"
          >
            <div v-if="isLoading" class="text-xs-center py-3">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
            <template v-else-if="!isLoading && total > 0">
              <FacebookTemplateItem
                v-for="item in items"
                :key="item.id"
                :value="item"
                :user-id="userId"
                editable
                sendable
                @edit="handleEdit(item)"
                @sending="isDialogLoading = true"
                @error:send="isDialogLoading = false"
                @sent="$emit('sent')"
              ></FacebookTemplateItem>
            </template>
            <div v-else class="text-xs-center py-3 grey--text">{{ $t('No data') }}</div>
          </FacebookTemplateList>
        </div>
      </v-card-text>
    </v-card>

    <FacebookTemplateFormDialog
      :open.sync="isFormDialogOpen"
      :value="selectedItem"
      @submitted="handleFormSubmitted"
    ></FacebookTemplateFormDialog>
  </v-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { mapGetters } from 'vuex'
import facebookTemplateApi from '@/api/facebook-template'
import FacebookTemplateList from './FacebookTemplateList.vue'
import FacebookTemplateItem from './FacebookTemplateItem.vue'
import FacebookTemplateFormDialog from './FacebookTemplateFormDialog.vue'

export default {
  components: {
    FacebookTemplateList,
    FacebookTemplateItem,
    FacebookTemplateFormDialog
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    userId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      items: [],
      query: '',
      filters: {
        query: '',
        page: 1,
        limit: 10
      },
      total: 0,
      selectedItem: null,
      isLoading: true,
      isFormDialogOpen: false,
      isDialogLoading: false,
      debounceSearch: debounce(() => {
        this.filters = { ...this.filters, query: this.query }
      }, 1000)
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    open(value) {
      if (value) {
        this.isDialogLoading = false
      }
    },
    filters: {
      immediate: true,
      handler() {
        this.fetchFacebookTemplates()
      }
    }
  },
  methods: {
    async fetchFacebookTemplates() {
      try {
        this.isLoading = true

        const response = await facebookTemplateApi.getAll({
          params: {
            page_id: this.selectedBot.pageid,
            name: this.filters.query,
            is_active: true,
            limit: this.filters.limit,
            offset: (this.filters.page - 1) * this.filters.limit
          }
        })

        if (response.status === 200) {
          this.items = response.data.data
          this.total = response.data.total
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    handlePageUpdate(page) {
      this.filters = { ...this.filters, page }
    },
    handleEdit(item) {
      this.selectedItem = item
      this.isFormDialogOpen = true
    },
    handleFormSubmitted() {
      this.isFormDialogOpen = false
      this.filters = { ...this.filters }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/facebook-template/FacebookTemplateSelectDialog.vue